<template>
  <div>
    <div v-if="!redactCity && !redactMayor && !redactState">
      <div class="message">
        <p class="message-body">
          Select one or more forms above
        </p>
      </div>
    </div>
    <div v-else>
      <div class="columns is-multiline">
        <div
          class="column is-12"
        >
          <form>
            <div
              v-show="redactCity"
              class="columns is-vcentered"
            >
              <div class="column is-full">
                <div class="field">
                  <div class="file has-name is-fullwidth">
                    <label class="file-label">
                      <input
                        id="cityFile"
                        class="file-input"
                        type="file"
                        accept="application/pdf"
                        @change="updateFileState('cityFile', $event)"
                      >
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload" />
                        </span>
                        <span class="file-label">
                          Choose a PDF
                        </span>
                      </span>
                      <span class="file-name">
                        {{ cityFileName !== '' ? cityFileName : 'City statment' }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="redactState"
              class="columns is-vcentered"
            >
              <div class="column is-full">
                <div class="field">
                  <div class="file has-name is-fullwidth">
                    <label class="file-label">
                      <input
                        id="stateFile"
                        class="file-input"
                        type="file"
                        accept="application/pdf"
                        @change="updateFileState('stateFile', $event)"
                      >
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload" />
                        </span>
                        <span class="file-label">
                          Choose a PDF
                        </span>
                      </span>
                      <span class="file-name">
                        {{ stateFileName !== '' ? stateFileName : 'State statment' }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="redactMayor"
              class="columns is-vcentered"
            >
              <div class="column is-full">
                <div class="field">
                  <div class="file has-name is-fullwidth">
                    <label class="file-label">
                      <input
                        id="mayorFile"
                        class="file-input"
                        type="file"
                        accept="application/pdf"
                        @change="updateFileState('mayorFile', $event)"
                      >
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload" />
                        </span>
                        <span class="file-label">
                          Choose a PDF
                        </span>
                      </span>
                      <span class="file-name">
                        {{ mayorFileName !== '' ? mayorFileName : 'Mayor statment' }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column has-text-centered">
                <button
                  id="modal-upload-btn"
                  type="button"
                  class="button is-primary"
                  :class="isSaving ? 'is-loading' : ''"
                  :disabled="isSaving"
                  @click.prevent="validateAndUpload"
                >
                  Upload
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  name: 'PaperRedactions',
  props: {
    filingId: {
      type: Number,
      required: true,
    },
    cityOfficialsCategory: {
      type: String,
      required: true,
    },
    stateOfficialsCategory: {
      type: String,
      required: true,
    },
    mayorOfficialsCategory: {
      type: String,
      required: true,
    },
    redactCity: {
      type: Boolean,
      required: true,
    },
    redactState: {
      type: Boolean,
      required: true,
    },
    redactMayor: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      cityFileName: '',
      stateFileName: '',
      mayorFileName: '',
      isSaving: false,
      cityFile: null,
      stateFile: null,
      mayorFile: null,
      inputStatementType: null,
      isAmended: null,
      isRedacted: null,
      officialsCategory: null,
      filerSumittedPaperStatements: true,
    };
  },
  methods: {
    updateFileState (target, event) {
      if (event.target.files.length) {
        Vue.set(this, target, event.target.files[0]);
        this[`${target}Name`] = event.target.files[0].name;
      }
    },
    async validateAndUpload() {

      if (!this.redactCity && !this.redactState && !this.redactMayor) {
        this.isSaving = false;
        return this.$warning('Please select a form type and corresponding Official\'s Category');
      }

      this.isSaving = true;

      let formData = new FormData();
      formData.append('filingId', this.filingId);

      if (this.redactCity) {
        if (!this.cityOfficialsCategory) {
          this.isSaving = false;
          return this.$warning('Please select a City Official\'s Category');
        }
        if (!this.cityFile) {
          this.isSaving = false;
          return this.$warning('Please select a City file to upload');
        }
        formData.append('cityFile', this.cityFile);
        formData.append('cityOfficialsCategory', this.cityOfficialsCategory);
      }

      if (this.redactState) {
        if (!this.stateOfficialsCategory) {
          this.isSaving = false;
          return this.$warning('Please select a State Official\'s Category');
        }
        if (!this.stateFile) {
          this.isSaving = false;
          return this.$warning('Please select a State file to upload');
        }
        formData.append('stateFile', this.stateFile);
        formData.append('stateOfficialsCategory', this.stateOfficialsCategory);
      }

      if (this.redactMayor) {
        if (!this.mayorOfficialsCategory) {
          this.isSaving = false;
          return this.$warning('Please select a Mayor Official\'s Category');
        }
        if (!this.mayorFile) {
          this.isSaving = false;
          return this.$warning('Please select a Mayor file to upload');
        }
        formData.append('mayorFile', this.mayorFile);
        formData.append('mayorOfficialsCategory', this.mayorOfficialsCategory);
      }

      this.$store.dispatch('filing/uploadPaperRedaction', formData).then(() => {
        this.isSaving = false;
        this.$success('Redaction completed.');
        this.$emit('redactionCompleted', true);
      });

    },
  },
};
</script>
<style lang="scss" scoped>
  .file-name {
    font-style: italic;
  }
</style>
